"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Header = void 0;
var React = __importStar(require("react"));
var styled_components_1 = __importDefault(require("styled-components"));
var antd_1 = require("antd");
var Layout_1 = require("../Layout");
var AI2Banner_1 = require("./AI2Banner");
var useSmartAI2Banner_1 = require("./useSmartAI2Banner");
// This is an alias we create so that the user doesn't have to mix abstraction
// levels when implemnting something more custom. This way the user can do everything
// with the <Header.*> components, and doesn't need to use the antd ones.
var Container = antd_1.Layout.Header;
var Content = (0, styled_components_1.default)(Layout_1.Content)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    display: flex;\n    align-items: center;\n    padding-top: 0;\n    padding-bottom: 0;\n"], ["\n    display: flex;\n    align-items: center;\n    padding-top: 0;\n    padding-bottom: 0;\n"])));
var Sticky = styled_components_1.default.div(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n    && {\n        position: sticky;\n        top: 0;\n        z-index: ", ";\n        width: 100%;\n        box-shadow: ", ";\n        transition: top 200ms ease-in-out;\n    }\n\n    .ant-layout-header {\n        height: initial;\n        padding: 0;\n        background: ", ";\n        line-height: initial;\n    }\n"], ["\n    && {\n        position: sticky;\n        top: 0;\n        z-index: ", ";\n        width: 100%;\n        box-shadow: ", ";\n        transition: top 200ms ease-in-out;\n    }\n\n    .ant-layout-header {\n        height: initial;\n        padding: 0;\n        background: ", ";\n        line-height: initial;\n    }\n"])), function (_a) {
    var theme = _a.theme;
    return theme.zIndex.header;
}, function (_a) {
    var theme = _a.theme;
    return theme.shadows.header;
}, function (_a) {
    var theme = _a.theme;
    return theme.palette.common.white.toString();
});
var AppName = function (_a) {
    var children = _a.children;
    if (children.length > 24) {
        console.warn('The contents of `<AppName>` should be fewer then 25 characters');
    }
    return React.createElement(AppNameText, null, children);
};
var AppNameText = styled_components_1.default.h3(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n    margin: 0;\n    padding: 0;\n    white-space: nowrap;\n    overflow: hidden;\n    text-overflow: ellipsis;\n\n    @media (max-width: ", ") {\n        font-size: ", ";\n    }\n"], ["\n    margin: 0;\n    padding: 0;\n    white-space: nowrap;\n    overflow: hidden;\n    text-overflow: ellipsis;\n\n    @media (max-width: ", ") {\n        font-size: ", ";\n    }\n"])), function (_a) {
    var theme = _a.theme;
    return theme.breakpoints.xs.toString();
}, function (_a) {
    var theme = _a.theme;
    return theme.typography.h4.fontSize;
});
var AppTagline = styled_components_1.default.h4(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n    margin: 0;\n    padding: 0;\n    white-space: nowrap;\n    overflow: hidden;\n    text-overflow: ellipsis;\n\n    @media (max-width: ", ") {\n        display: none;\n    }\n"], ["\n    margin: 0;\n    padding: 0;\n    white-space: nowrap;\n    overflow: hidden;\n    text-overflow: ellipsis;\n\n    @media (max-width: ", ") {\n        display: none;\n    }\n"])), function (_a) {
    var theme = _a.theme;
    return theme.breakpoints.xs.toString();
});
var LogoGrid = styled_components_1.default.span(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n    display: grid;\n    grid-template-columns: repeat(4, auto);\n    align-items: center;\n    gap: ", ";\n\n    &:hover ", " {\n        text-decoration: none;\n        display: inline-block;\n    }\n"], ["\n    display: grid;\n    grid-template-columns: repeat(4, auto);\n    align-items: center;\n    gap: ", ";\n\n    &:hover ", " {\n        text-decoration: none;\n        display: inline-block;\n    }\n"])), function (_a) {
    var theme = _a.theme;
    return theme.spacing.xs.toString();
}, AppNameText);
// Wraps the header logo with an ahref if href is passed in
var ConditionalAnchorWrapper = function (props) {
    return props.href ? (React.createElement(DecorationlessAnchor, { href: props.href, rel: "noopener noreferrer" }, props.children)) : (props.children);
};
var DecorationlessAnchor = styled_components_1.default.a(templateObject_6 || (templateObject_6 = __makeTemplateObject(["\n    &&:hover {\n        text-decoration: none;\n    }\n"], ["\n    &&:hover {\n        text-decoration: none;\n    }\n"])));
var Logo = function (props) {
    return (React.createElement(ConditionalAnchorWrapper, { href: props.href },
        React.createElement(LogoGrid, { className: props.className },
            props.children,
            props.label,
            props.label && props.tagline ? (props.separator ? (props.separator) : (React.createElement(AppTagline, null, "\u2014"))) : null,
            props.tagline)));
};
var Columns = styled_components_1.default.div(templateObject_7 || (templateObject_7 = __makeTemplateObject(["\n    display: grid;\n    grid-template-columns: ", ";\n    grid-column-gap: ", ";\n    grid-row-gap: ", ";\n    width: 100%;\n    align-items: center;\n    padding: ", " 0;\n"], ["\n    display: grid;\n    grid-template-columns: ", ";\n    grid-column-gap: ", ";\n    grid-row-gap: ", ";\n    width: 100%;\n    align-items: center;\n    padding: ", " 0;\n"])), function (_a) {
    var columns = _a.columns;
    return columns;
}, function (_a) {
    var theme = _a.theme;
    return theme.spacing.md.toString();
}, function (_a) {
    var theme = _a.theme;
    return theme.spacing.md.toString();
}, function (_a) {
    var theme = _a.theme;
    return theme.spacing.sm.toString();
});
var MenuColumn = styled_components_1.default.div(templateObject_8 || (templateObject_8 = __makeTemplateObject(["\n    &&&& {\n        justify-self: right;\n        line-height: 77px;\n        a:hover {\n            text-decoration: none;\n        }\n        ul {\n            margin: -", " 0;\n        }\n    }\n"], ["\n    &&&& {\n        justify-self: right;\n        line-height: 77px;\n        a:hover {\n            text-decoration: none;\n        }\n        ul {\n            margin: -", " 0;\n        }\n    }\n"])), function (_a) {
    var theme = _a.theme;
    return theme.spacing.sm.toString();
});
function HeaderComponent(_a) {
    var alwaysVisible = _a.alwaysVisible, children = _a.children;
    var _b = (0, useSmartAI2Banner_1.useSmartAI2Banner)(), sticky = _b[0], banner = _b[1], offsetTop = _b[2];
    return (React.createElement(Sticky, { ref: sticky, style: { top: "".concat(!alwaysVisible ? offsetTop : 0, "px") } },
        React.createElement(antd_1.Layout.Header, null,
            React.createElement(AI2Banner_1.AI2Banner, { ref: banner }),
            React.createElement(Content, null, children))));
}
/**
 * Merge in the components that are tightly coupled to the <Header>,
 * so that they can be used like:
 *  <Header>
 *      <Header.Columns>
 *          ...
 *      </Header.Columns>
 *  </Header>
 */
exports.Header = Object.assign(HeaderComponent, {
    AI2Banner: AI2Banner_1.AI2Banner,
    AppName: AppName,
    AppTagline: AppTagline,
    Columns: Columns,
    Content: Content,
    Container: Container,
    Logo: Logo,
    MenuColumn: MenuColumn,
    Sticky: Sticky,
});
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6, templateObject_7, templateObject_8;
//# sourceMappingURL=Header.js.map